import React from 'react';
import { bonuses } from '../data/content';
import { ImageSlot } from './ImageSlot';
import { SectionHeading } from './SectionHeading';
type BonusesSectionProps = {
  bonusCovers: string[];
};
export function BonusesSection({
  bonusCovers
}: BonusesSectionProps) {
  return <section aria-labelledby="bonuses-title" className="bg-cream py-12 md:py-20" data-id="element-20" data-mp="qtt7eqcv6v9u">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-21" data-mp="qvw2vpwsdgly">
        <SectionHeading id="bonuses-title" eyebrow={bonuses.eyebrow} title={bonuses.title} data-id="element-22" data-mp="14sj5a87icyz9" />

        <ul className="mt-8 grid gap-4 md:mt-12 md:grid-cols-2" data-id="element-23" data-mp="ztg97d9ia33f">
          {bonuses.items.map((b, i) => {
          const featured = i === 0;
          return <li key={b.label} className={`flex flex-col overflow-hidden rounded-xl border bg-white sm:flex-row sm:items-center sm:gap-6 sm:p-5 ${featured ? 'border-orange md:col-span-2 md:gap-8 md:p-7' : 'border-cream-line'}`} data-id="element-24" data-mp="19kko6cz6lny9" data-mpi={i}>
                <div className={`flex aspect-[4/3] w-full shrink-0 items-center justify-center bg-teal-tint p-4 sm:aspect-[3/4] sm:rounded-lg sm:p-2 ${featured ? 'sm:w-36 md:w-44' : 'sm:w-32'}`} data-id="element-25" data-mp="3pqttajeazveb">
                  <ImageSlot url={bonusCovers[i]} alt={`${b.title} cover`} slotName={`bonusCovers[${i}]`} fit="contain" data-id="element-26" data-mp="7kpaemfxsish" />
                </div>
                <div className="min-w-0 p-5 sm:p-0" data-id="element-27" data-mp="ciqu99l6sm50">
                  <span className="inline-block rounded-md bg-gold px-2 py-1 font-display text-[11px] font-extrabold tracking-[0.08em] text-teal-dark" data-id="element-28" data-mp="chz4wgi6nkn6">
                    {b.label}
                  </span>
                  <p className="mt-3 text-[15px] font-semibold text-orange-ink" data-id="element-29" data-mp="qb6xobi02m6g">{b.hook}</p>
                  <h3 className={`mt-1 font-display font-extrabold uppercase leading-snug tracking-tight text-teal ${featured ? 'text-[18px] md:text-[24px]' : 'text-[17px]'}`} data-id="element-30" data-mp="va9uj8nttm3c">
                    {b.title}
                  </h3>
                  <p className="mt-2 text-[16px] leading-relaxed text-ink/75" data-id="element-31" data-mp="5me847m14szh">{b.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}